import styled from 'styled-components'

import CookUnityLogo from '../../assets/svg/logo-cookunity.svg'

export const View = styled.div`
  box-sizing: border-box;
  width: 100 vw;
  height: 100 vh;
  display: flex;
  justify-content: center;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url(https://i2.wp.com/hospitality21.com/wp-content/uploads/2015/04/o-CHEFS-KITCHEN-facebook.jpg?fit=2000%2C1000&ssl=1);
`
export const Card = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: center;
  align-items: center;

  box-sizing: border-box;
  margin: auto 0%;

  background: #ffffff;
`
export const Logo = styled.img.attrs({
  src: CookUnityLogo
})`
  width: 100%;
  margin: 10% 0px 0px 0px;
`

export const LoginBtn = styled.button`
  width: 100%;
  border-radius: 6px;
  padding: 0.8em;
  text-transform: none;
  font-size: 1.4em;
  background: black;
  margin: 20px 0px;
  border: none;
  color: white;
  cursor: pointer;
`
